<template>
	<div class="app-container" @click="hidePannel()">
       
		<!-- 时钟 -->
		<div class="clock">
			<clock :time="time" bg="radial-gradient(circle, #ecffe5, #ffffff, #f9ffcd)"></clock>
		</div>
		<!-- 在线咨询 -->
		<div class="online" @click="openUrl('/main/zxzxForm')" />
		<!-- 导航面板 -->
		<div class="nvlPannel">
			<el-row :gutter="20">
				<el-col :span="6" v-for="(item, index) in pannelList" :key="item.name">
					<div class="content" v-show="isActive==item.name">
						<h4>{{item.name}}</h4>
						<el-row :gutter="15">
							<el-col style="margin-bottom: 5px;text-align: left;" :span="12"
								v-for="(itemchild, index) in item.labels" :key="itemchild.label">
								<el-button @click="openUrl(itemchild.url)" size="mini" type="primary">
									{{itemchild.label}}
								</el-button>
							</el-col>
						</el-row>
					</div>
					<!-- 虚拟dom,用来空置div高度的。当display=none时，浏览器高度为0  用其他办法吗？？？？-->
					<div style="height: 200px;" v-show="isActive!=item.name" />
					<!-- 热点区域选择div -->
					<div style="height: 120px" @mouseover="showPannel(item.name)"></div>
					<!-- 	<div style="height: 120px;background-color: #004B99;margin-left: -15px;"  @mouseover="showPannel(item.name)"  ></div>	 -->
				</el-col>

			</el-row>
		</div>
		<!-- 个人企业中心 -->
		<div class="home">
			<div style="float:right;cursor: pointer;" @click="toPage('/main/index')"><i class="el-icon-s-home"></i>
				<u>进入平台</u>
			</div>
			<div class="home-icon">
				<img v-if="ftype==='1'" src="../../assets/images/hkdt/user.png" />
				<img v-if="ftype==='2'" src="../../assets/images/hkdt/enticon.png" />
			</div>
			<div class="home-ent">
				<h5>{{name}}</h5>
				<el-button v-if="ftype==='1'" type="warning" @click="openUrl('/qygzs')">个人工作室</el-button>
				<el-button v-if="ftype==='2'" type="warning" @click="openUrl('/qygzs')">企业工作室</el-button>
			</div>

		</div>
		 
	</div>
	
</template>

<script>
	import Clock from 'vue-clock2';
	import {updatePvNum} from "@/api/itempv/pv";
	import {
		getSsoDesInfo,
	} from "@/api/zlts/jlfw/jljgxx";
	export default {
		name: "Xwqycx",
		components: {
			Clock

		},
		data() {
			return {
				// 遮罩层
				loading: true,
				// 总条数
				total: 0,
				// 是否显示弹出层
				open: false,
				// 查询参数
				time: undefined,
				loginUser:{},
				//个人/企业名称
				name:'未登录',
				//当前登录用户类型ftype 1-个人 2-企业
				ftype:undefined,
				pannelList: [{
						name: '知识产权综合服务',
						labels: [ {
							label: '知识产权服务联盟',
							url: '/main/zscqzhfw/fwlmjj'
						}, {
							label: '质押融资服务',
							url: '/main/zscqzhfw/zyrzfw'
						}, {
							label: '知识产权超市',
							url: '/main/zscqzhfw/zscqcs'
						}, {
							label: '国家知识产权局专利检索与分析',
							url: 'http://pss-system.cnipa.gov.cn/sipopublicsearch/portal/uiIndex.shtml'
						}, {
							label: '国家知识产权局商标查询',
							url: 'http://wcjs.sbj.cnipa.gov.cn/txnT01.do'
						}, {
							label: '山东省新旧动能转换专利库',
							url: 'http://123.233.241.76:8090/'
						}, {
							label: '科技云专利检索分析',
							url: 'http://kjy.weihai.cn/middleLogin'
						}, {
							label: '威海市专利查询',
							url: '/main/zscqzhfw/whszl'
						}, {
							label: '培训服务',
							url: 'main/zltszhfw/pxfw'
						}]
					},
					{
						name: '质量提升综合服务',
						labels: [{
							label: '计量服务',
							url: '/main/zltszhfw/jlfw'
						}, {
							label: '标准服务',
							url: '/main/zltszhfw/bzfw'
						}, {
							label: '认证认可',
							url: '/main/zltszhfw/rzfw'
						}, {
							label: '质量及品牌',
							url: '/main/zltszhfw/zlypp'
						}]
					},
					{
						name: '小微企业成长服务',
						labels: [{
							label: '小微企业查询',
							url: '/main/xwqyczfw/xwqycx'
						}, {
							label: '党建引领',
							url: '/main/xwqyczfw/djyl'
						}, {
							label: '文明诚信引领',
							url: '/main/xwqyczfw/wmcxyl'
						}, {
							label: '融资服务',
							url: '/main/xwqyczfw/rzfw'
						}, {
							label: '法律维权服务',
							url: '/main/xwqyczfw/flwqdxalyfx'
						}, {
							label: '人才对接',
							url: '/main/xwqyczfw/rcdj'
						}]
					},
					{
						name: '检验检测服务',
						labels: [{
							label: '产品质量检测',
							url: '/main/jyjcfw/cpzljc'
						}, {
							label: '食品检测',
							url: 'os_spjc'
						}, {
							label: '计量检测',
							url: 'os_jls'
						}, {
							label: '特种设备检测',
							url: '/main/jyjcfw/tzsbjc'
						}]

					},

				],
				isActive: undefined,
				ssoOtherOsInfo: {},

			};
		},
		created() {
			updatePvNum("3d_hkdt").then(response => {
				//pv 点击3d会客大厅
			});
			this.getSdtyfwptLoginUser();
			this.$emit('footer', false);
			this.nowTimes();
		//	this.getLoginUser();
		},
		methods: {
			//----【】需要修改为recid
			getSdtyfwptLoginUser(){
				this.ftype = JSON.parse(localStorage.getItem("ssessionLoginUser")).user.ftype;//用户类型
				if(this.ftype == null || this.ftype ==='' || this.ftype === undefined){
					this.ftype='0';//默认为0
					this.name='未登录'
				}else{
					if(this.ftype ==='1'){
						this.ftype='1';//个人用户
						this.name='您好，个人用户'
					}else{
						this.ftype='2';//企业
						this.name=JSON.parse(localStorage.getItem("ssessionLoginUser")).user.realName;
					}
				}
			},
			timeFormate(timeStamp) {

				let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp)
					.getHours();
				let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(
					timeStamp).getMinutes();
				let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(
					timeStamp).getSeconds();
				this.time = hh + ":" + mm + ':' + ss;
			},
			nowTimes() {
				this.timeFormate(new Date());
				setInterval(this.time, 1000);
				this.clear()
			},
			clear() {
				clearInterval(this.time)
				this.time = null;
			},
			showPannel(item) {
				this.isActive = item;

			},
			hidePannel() {
				this.isActive = false;

			},
			openUrl(url) {
				//----【】需要修改为recid
				//判断一下 单点登录的系统
				//          食品                计量
				if(url ==='os_spjc' || url ==='os_jls'){
					let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
					if (this.utils.isLoginTimeout()) {
						this.ssoOtherOsInfo.syscode = syscode;
						this.ssoOtherOsInfo.uuid = ssessionLoginUser.ywFwjg.uuid;
						this.ssoOtherOsInfo.usertype = ssessionLoginUser.user.ftype;
						this.ssoOtherOsInfo.loginname = ssessionLoginUser.user.realName;
						this.ssoOtherOsInfo.entname = ssessionLoginUser.user.corname;
						this.ssoOtherOsInfo.entnumber = ssessionLoginUser.user.cornumber;
						this.ssoOtherOsInfo.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
						getSsoDesInfo(this.ssoOtherOsInfo).then(response => {
							this.openNewPage(response.url + "?syscode=" + url + "&sign=" +
								response.sign);
							return true;
						});
					} else {
						let ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
						this.$confirm(
							'登录请求已过期，您可以继续留在该页面，或者重新登录?',
							'系统提示', {
								confirmButtonText: '重新登录',
								cancelButtonText: '取消',
								type: 'warning'
							}
						).then(() => {
							this.logout(ywFwjgRecid)
						})
					}
				}else{
					this.utils.windowOpen(url);
				}


			},
            toPage(url){

                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);

            },
			openNewPage(url) {
				this.utils.windowOpen(url);
			},
		}
	}
</script>

<style scoped>
	.app-container {
		position: fixed;
		background-image: url("../../assets/images/hkdt/bg.jpg");
		background-size: 100% 100%;
		width: 100%;
		height: 768px;
		overflow:hidden;

	}

	.clock {

		z-index: 9999999;
		position: relative;
		width: 120px;
		height: 120px;
		top: 16%;
		left: 4%;
	}

	.online {
		cursor: pointer;
		z-index: 9999;
		position: relative;
		width: 90px;
		height: 40px;
		top: 30%;
		left: 20%;
		background-image: url("../../assets/images/hkdt/online.png");
		background-size: 100% 100%;
	}

	.nvlPannel {

		z-index: 9999;
		position: fixed;
		padding: 5px;
		text-align: center;
		width: 60%;
		height: 360px;
		top: 70px;
		left: 30%;
	}

	.nvlPannel .content {
		z-index: 9999;
		position: relative;
		padding: 15px;
		text-align: center;
		height: 260px;
		width: 310px;
		background-image: url("../../assets/images/hkdt/module_bg.png");
		background-size: 100% 100%;
		cursor: pointer;
	}

	.home {

		z-index: 9999;
		position: fixed;
		padding: 15px;
		width: 12%;
		height: 320px;
		top: 380px;
		left: 81%;
		color: #FFFFFF;

	}

	.home-icon {
		left: 39%;
		top: 16%;
		position: relative;
	}

	.home-ent {
		text-align: center;
		top: 20%;
		left: 5%;
		width: 95%;
		position: relative;

		word-wrap: break-word;
		word-break: break-all;
		overflow: hidden;
	}

	 
</style>
